import React from 'react'
import { Accordion, Col, Row } from 'react-bootstrap'
import carIocn from "../../assets/images/car.png";
import whyimg from "../../assets/images/a.jpg";
export default function WhyChoose() {
  return (
    <div>
      <div className="services-one">
        <div className="services-one__shape-1"></div>
        <div className="services-one__shape-2"></div>
        {/* your actual content here */}
        <div className="container">
          <div className="section-title mb-4">
            <img src={carIocn} alt="" />
            <h2>Why Choose Taxi Service Varanasi?</h2>
          </div>
          <Row>
            <Col xs={12} sm={6} md={4} lg={5}>
              <div className="mb-4">
                <img src={whyimg} alt="" className="w-100 rounded-4" />
              </div>
            </Col>
            <Col xs={12} sm={6} lg={7}>
              <div className="Accordion_Style">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <i className="fa-regular fa-clock "></i> 24/7 Availability
                    </Accordion.Header>
                    <Accordion.Body>
                      Round-the-clock cab service across Varanasi. Always ready
                      to serve you anytime, anywhere.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <i className="bi bi-shield-shaded"></i> Verified Drivers
                    </Accordion.Header>
                    <Accordion.Body>
                      Background-verified, professionally trained drivers. Your
                      safety and comfort are our top priorities.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      <i className="bi bi-currency-rupee"></i> Transparent
                      Pricing
                    </Accordion.Header>
                    <Accordion.Body>
                      No hidden charges, no surge pricing! Get upfront quotes
                      with complete transparency.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      <i className="bi bi-car-front-fill"></i> Premium Fleet
                    </Accordion.Header>
                    <Accordion.Body>
                      Well-maintained, clean, and comfortable vehicles with AC.
                      Sanitized before every ride.
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <i className="bi bi-journal-text"></i> Instant Booking
                    </Accordion.Header>
                    <Accordion.Body>
                      Get confirmed rides within minutes. No waiting, no delays
                      - just quick bookings!
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      <i className="bi bi-patch-check"></i> Safety First
                    </Accordion.Header>
                    <Accordion.Body>
                      GPS tracking on every ride and 24/7 emergency support
                      available.
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>
          </Row>
        </div>
        <div></div>
      </div>
    </div>
  )
}
